<template>
  <div id="api-docs-navigation" class="navigation-section" data-cy="api-docs-navigation">
    <router-link
      v-for="anchor in anchors"
      :key="anchor.id"
      v-slot="{ navigate }"
      custom
      :to="`#${decodeURIComponent(anchor.id)}`"
    >
      <v-button appearance="filled" shape="pill" :label="anchor.textContent || ''" unelevated="" @click="navigate" />
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { VButton } from '@vonage/vivid-vue';

defineProps<{
  anchors: Element[];
}>();
</script>
